var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.customers.length || _vm.isTemporaryResult
        ? _c(
            "q-toolbar",
            {
              staticClass: "top-page-toolbar",
              attrs: { color: "white", "text-color": "grey-9" }
            },
            [
              _c("q-toolbar-title", [
                _c("div", { staticClass: "row items-center" }, [
                  _c(
                    "div",
                    { staticClass: "top-page-toolbar__type-filter" },
                    [
                      _c("q-select", {
                        attrs: {
                          options: _vm.filterOptions,
                          color: "grey-9",
                          radio: "",
                          "hide-underline": ""
                        },
                        on: { input: this.filterCustomerType },
                        model: {
                          value: _vm.customerFilter,
                          callback: function($$v) {
                            _vm.customerFilter = $$v
                          },
                          expression: "customerFilter"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c(
                "q-icon",
                { attrs: { name: "more_vert" } },
                [
                  _c("customer-popover", {
                    attrs: { customers: _vm.checkedCustomers, multiple: "" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "layout-padding" },
        [
          _vm.customers.length
            ? _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  {
                    staticClass: "col",
                    class: { "col-xl-4": _vm.selectedCustomer }
                  },
                  [
                    _c("customer-table", {
                      staticClass: "bg-white overflow-hidden"
                    })
                  ],
                  1
                ),
                _vm.selectedCustomer
                  ? _c(
                      "div",
                      { staticClass: "col-xl-8" },
                      [_c("router-view")],
                      1
                    )
                  : _vm._e()
              ])
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-center items-center col-grow q-pt-lg"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("assets/emptystates/contacts_empty.svg")
                          }
                        }),
                        _c("h6", { staticClass: "q-my-md text-faded" }, [
                          _vm._v(_vm._s(_vm.$t("no_partners")))
                        ]),
                        _c(
                          "q-btn-dropdown",
                          {
                            staticClass: "q-mt-lg",
                            attrs: {
                              label: _vm.$t("create_partner"),
                              color: "primary",
                              outline: ""
                            }
                          },
                          [
                            _c(
                              "q-list",
                              { attrs: { link: "" } },
                              [
                                _c(
                                  "q-item",
                                  {
                                    directives: [
                                      {
                                        name: "close-overlay",
                                        rawName: "v-close-overlay"
                                      }
                                    ],
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.$refs.customerModal.handleAddCustomer(
                                          "person"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$tc("person", 1) }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-item",
                                  {
                                    directives: [
                                      {
                                        name: "close-overlay",
                                        rawName: "v-close-overlay"
                                      }
                                    ],
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.$refs.customerModal.handleAddCustomer(
                                          "company"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$tc("company", 1) }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
        ],
        2
      ),
      _c("add-customer-modal", {
        directives: [{ name: "is-user", rawName: "v-is-user" }],
        ref: "customerModal"
      }),
      _c("customer-export-modal", { ref: "customerExportModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }